import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

const helpers = window.BASE_HELPERS || {};
const { Forms, MessageBox } = helpers;

const MODULE = document.querySelectorAll('[data-module="newsletter"]');

class Newsletter {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {

            const FORM = component.querySelector('.newsletter');
            const MESSAGE = component.querySelector('[data-newsletter-message]');
            const MESSAGE_ERROR = component.dataset.messageError || '';
            const MESSAGE_SUCCESS = component.dataset.messageSuccess || i18n?.message?.formNewsletterSuccess || '';
            const MESSAGE_INVALID = 'Por favor, insira um e-mail válido';
            let clearTimer = null;

            const clearMessage = () => {
                clearTimeout(clearTimer);
                if (!MESSAGE) return;
                MESSAGE.textContent = '';
                component.removeAttribute('data-state');
            };

            const showMessage = (state, text) => {
                clearTimeout(clearTimer);
                MESSAGE.textContent = text;
                component.setAttribute('data-state', state);
            };

            FORM.addEventListener('input', clearMessage);

            new Bouncer('.newsletter', {
                disableSubmit: true,
                messageAfterField: false,
                messages: {
                    missingValue: {
                        default: 'Campo de preenchimento obrigatório',
                    },
                    patternMismatch: {
                        email: 'Por favor, insira um e-mail válido',
                    },
                },
                emitEvents: true,
            });

            FORM.addEventListener('bouncerShowError', (event) => {
                if (!MESSAGE) {
                    FORM.classList.add('has-message');
                    return;
                }

                const errors = event.detail?.errors || {};
                const text = errors.missingValue
                    ? (MESSAGE_ERROR || errors.missingValue)
                    : MESSAGE_INVALID;

                showMessage('error', text);
            });

            FORM.addEventListener('bouncerRemoveError', (event) => {
                if (!MESSAGE) {
                    FORM.classList.remove('has-message');
                }
            });

            FORM.addEventListener('bouncerFormValid', async (event) => {
                event.preventDefault();

                const formEl = event.target;
                const submitEl = formEl.querySelector('[type="submit"]');
                submitEl?.setAttribute('disabled', 'disabled');
                FORM.classList.remove('has-message');
                clearMessage();

                window.reloadCaptcha('submit', 'recaptcha_token', async () => {
                    const payload = new FormData(formEl);

                    try {
                        const url = `${AppSettings.baseApiUrl}basedigital/v1/newsletter`;
                        const response = await axios.post(url, payload, { timeout: 30000 });

                        if (MESSAGE) {
                            showMessage('success', MESSAGE_SUCCESS);
                            clearTimer = setTimeout(clearMessage, 8000);
                        } else {
                            MessageBox.showOnce({
                                target: FORM,
                                position: 'bottom',
                                type: 'success',
                                message: MESSAGE_SUCCESS,
                                classes: 'text-xs text-azul-escuro',
                                timeout: 8000,
                            });
                        }
                    } catch (e) {
                        console.error(e);

                        if (MESSAGE) {
                            showMessage('error', MESSAGE_ERROR || i18n?.message?.formNewsletterError || 'Não foi possível concluir a inscrição. Tente novamente.');
                            clearTimer = setTimeout(clearMessage, 8000);
                        }
                    } finally {
                        formEl.reset();
                        submitEl?.removeAttribute('disabled');
                        setTimeout(() => {
                            FORM.classList.remove('has-message');
                        }, 5000)
                    }
                });
            });
        });
    }
}

(() => {
    if (MODULE) {
        new Newsletter();
    }
})();

export default Newsletter;
